import { thumbnailPathFrom } from "../../Utils/thumbnailPath";
import React, { useContext, useState, useEffect, useRef } from "react";
import ProjectContext from "../../context/ProjectContext";
import { Tooltip } from "react-tippy";
import axios from "axios";
import AuthContext from "../../context/userAuth.context";
import MyContext from "../../context/MyContext";
import Popup from "reactjs-popup";
import swal from "sweetalert";
import swal2 from "sweetalert2";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import CustomDropDown from "./customDropDown";
import MyVideoRenders from "./myVideoRenders";
import { listMyExports } from "../../Utils/exportApi";
import { packProjectData } from "../../Utils/projectPack";
import { postJson } from "../../Utils/compressedUpload";
import { linkEmbeddedImages } from "../../Utils/layerImages";
import Swal from "sweetalert2";

const clone = (obj) => {
  var copy;
  if (null === obj || "object" != typeof obj) return obj;
  if (obj instanceof Date) {
    copy = new Date();
    copy.setTime(obj.getTime());
    return copy;
  }
  if (obj instanceof Array) {
    copy = [];
    for (var i = 0, len = obj.length; i < len; i++) {
      copy[i] = clone(obj[i]);
    }
    return copy;
  }
  if (obj instanceof Object) {
    copy = {};
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
    }
    return copy;
  }
  throw new Error("Unable to copy obj! Its type isn't supported.");
};

export const Navbar = (props) => {
  const {
    slides,
    setClear,
    changes,
    CurrentProject,
    setCurrentProject,
    setChangeCount,
    setDeafultLoader,
    DeafultLoader,
    setchanginCanvasSize,
    setSlide_background_image,
    setchanges,
    projectEditorZoom,
    ChangeCount,
    LayersData,
    watermark,
    bgmusicState,
  } = useContext(ProjectContext);

  const { authenticationData, Role, Access, getLink } = useContext(AuthContext);

  const [Name, setName] = useState(
    CurrentProject.projectName ? CurrentProject.projectName : "Your Project"
  );

  const [openMyVidModal,setOpenMyVidModal] = React.useState(false)

  const [NameChange, setNameChange] = useState(true);
  const [Call_ScreenShot, setCall_ScreenShot] = useState(false);
  const [MyVideoRenderModel, setMyVideoRenderModel] = useState(false);
  const interval = useRef();

  const changeName = () => {
    setNameChange(false);
  };
  useEffect(() => {
    if (document.getElementById("pnameID") != null)
      document.getElementById("pnameID").focus();
  }, [NameChange]);
  const [updateInterval, setupdateInterval] = useState(false);
  useEffect(() => {
    if (Role != "admin") {
      //setChangeCount((count) => count + 1);
      // interval.current = setInterval(function () {
      //   saveProject(true);
      // }, 10 * 1000);
      // return () => {
      //   clearInterval(interval.current);
      // };
    }
  }, [LayersData, watermark]);

  // useEffect(() => {
  //   if (Role != "admin") {
  //     if (ChangeCount > 5) {
  //       saveProject(true);
  //     }
  //   }
  // }, [ChangeCount]);

  const showPreview = () => {
    var data = null;
    if (CurrentProject.canvasSize === "16:9") {
      data = calculateAspectRatioFit(
        16,
        9,
        window.innerWidth - 100,
        window.innerHeight - 100
      );
    } else if (CurrentProject.canvasSize === "1:1") {
      data = calculateAspectRatioFit(
        1,
        1,
        window.innerWidth - 100,
        window.innerHeight - 100
      );
    } else if (CurrentProject.canvasSize === "9:16") {
      data = calculateAspectRatioFit(
        9,
        16,
        window.innerWidth - 100,
        window.innerHeight - 100
      );
    }

    props.setPopupWidthHeight({
      width: data.width,
      height: data.height,
    });
    props.setpopupload(true);
  };

  function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
    var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return { width: srcWidth * ratio, height: srcHeight * ratio };
  }

  // Project data as saved to the server: each animation stored once (see Utils/projectPack.js),
  // without the background images converted to base64 for thumbnails (convertedImage /
  // convertedAnimated), which are only used at capture time.
  const projectDataForSave = (data) =>
    packProjectData(data, [
      "convertedImage",
      "convertedAnimated",
      // Thumbnail-only copies (pictures/shapes/characters as images). Thumbnails build them fresh,
      // so they never need to be saved; older versions saved them by mistake.
      "ConvertedImageSrc",
      "convertedPropsImage",
      "convertedSvg",
      "convertedSVG",
      "convertedBasicShape",
      "convertedShapePath",
      // Thumbnail spinner state (editor only).
      "slideLoader",
    ]);

  // Pictures still embedded in image layers (older projects) are moved to the server first and
  // replaced by their address (Utils/layerImages.js), so this and every later save is smaller.
  // A picture that cannot be moved stays embedded; the save goes ahead either way.
  const prepareProjectData = async (data) => {
    try {
      const slidesOrLayers = Array.isArray(data) && data.some((x) => x && Array.isArray(x.LayerData)) ? data : [{ LayerData: data }];
      await linkEmbeddedImages(authenticationData.ApiBaseURL, slidesOrLayers, LayersData);
    } catch (e) {
      console.log("Pictures stay embedded for this save.", e);
    }
    return projectDataForSave(data);
  };

  const ChangedName = (params) => {
    if (params.key === "Enter") {
      CurrentProject.projectName = Name;
      setNameChange(true);
      setChangeCount(6);
      // (A full copy used to be written to localStorage here. Nothing reads it, and big
      // projects do not fit in localStorage.)
      localStorage.removeItem("CurrentChooseProject");
    }
  };

  const Textblur = () => {
    CurrentProject.projectName = Name;
    setNameChange(true);
    // (A full copy used to be written to localStorage here. Nothing reads it, and big
    // projects do not fit in localStorage.)
    localStorage.removeItem("CurrentChooseProject");
  };

  const clearAll = () => {
    swal({
      title: "Are you sure you want to clear current slide data?",
      text: "You won't be able to revert this!",
      icon: "warning",
      buttons: [true, "Yes, Clear it!"],
      cancelButtonColor: "#d33",
      // confirmButtonText: "Yes, Clear it!",
      dangerMode: true,
      backdrop: null,
    }).then((willDelete) => {
      if (willDelete) {
        setClear(true);
      }
    });

    // swal2
    //   .fire({
    //     title: "Are you sure you want to clear current slide data?",
    //     text: "You won't be able to revert this!",
    //     icon: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "Yes, Clear it!",
    //     backdrop: null,
    //   })
    //   .then((result) => {
    //     if (result.isConfirmed) {
    //       setClear(true);
    //     }
    //   });
  };

  // let authData = JSON.parse(
  //   localStorage.getItem("animation_studio_2.0_access_token")
  // );

  // const CreateTemplate = () => {
  //   return new Promise((resolve, reject) => {
  //     console.log(props.LayersData);
  //     let ProjectAspectRatio = sessionStorage.getItem("ProjectAspectRatio");

  //       }).then((result) => {
  //           if (result.isConfirmed) {
  //               setClear(true);
  //           }
  //       })

  //   }

  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );

  const CreateTemplate = () => {
    return new Promise(async (resolve, reject) => {
      // debugger
      //console.log(props.LayersData);
      props.LayersData.map((value) => {
        value.DrapEndAnimatedText = false;
        value.endTimeOfAnimatedText = undefined;
        value.speedOn = false;
        value.fastspeedOn = false;
        value.startTimeOnTimeline = false;
        value.LoadLottie = true;
      });

      let ProjectAspectRatio = sessionStorage.getItem("ProjectAspectRatio");

      props.LayersData.forEach((element) => {
        element.index = element.layerIndex;
        if (element.type === "Character") {
          //element.JSONValue = null;
          element.OriginalJSONValue = null;
        }
      });

      let UserProjects = {
        CanvasSize: ProjectAspectRatio,
        ProjectData: await prepareProjectData(props.LayersData),
      };
      postJson(
          authenticationData.ApiBaseURL + "/api/Template/CreateTemplate",
          JSON.stringify(UserProjects),
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          if (response != null) {
            // debugger
            let array = clone(response.data.currentItem);
            // const Slider = Array.from(slides);
            // for (let i = 0; i < Slider.length; i++) {
            //   if (Slider[i].IsActive === true) {
            //     Slider[i].LayerData = props.LayersData;
            //     // Slider[i].SlideBackground = props.SlideBackground
            //     break;
            //   }
            // }
            // array.projectData = JSON.stringify(Slider);
            // if (response.data.result) {
            //   setAllProject(response.data.result);
            // } else {
            //   setAllProject([]);
            // }
            setCurrentProject(JSON.parse(JSON.stringify(array)));

            //localStorage.setItem("CurrentChooseProject", JSON.stringify(array));

            // localStorage.setItem('CurrentChooseProject', JSON.stringify(data.currentItem));
            resolve(response.data);
            // history.push('./editor')
          }
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  };

  // const updateTemplate = (id) => {
  //     return new Promise((resolve, reject) => {
  //         debugger
  //         let array = clone(CurrentProject);
  //   let UserProjects = {
  //     CanvasSize: ProjectAspectRatio,
  //     ProjectData: JSON.stringify(props.LayersData),
  //   };
  //   fetch(authenticationData.ApiBaseURL + "/api/Template/CreateTemplate", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       "Access-Control-Allow-Origin": "*",
  //       Authorization: "Bearer " + authData.access_token,
  //     },
  //     body: JSON.stringify(UserProjects),
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data != null) {
  //         let array = clone(data.currentItem);
  //         const Slider = Array.from(slides);
  //         for (let i = 0; i < Slider.length; i++) {
  //           if (Slider[i].IsActive === true) {
  //             Slider[i].LayerData = props.LayersData;
  //             break;
  //           }
  //         }

  //         let url = null
  //         let check = false
  //         for (let i = 0; i < Slider.length; i++) {
  //             if (Slider[i].SlideImage != null) {
  //                 url = Slider[i].SlideImage
  //                 check = true
  //                 break
  //             }
  //         }
  //         if (check == false) {
  //             for (let i = 0; i < Slider.length; i++) {
  //                 if (Slider[i].SlideBackground.Path != null) {
  //                     url = Slider[i].SlideBackground.Path
  //                     break
  //                 }
  //             }
  //         }
  //         let max_img_path = sessionStorage.getItem("max_img_path")

  //         if (max_img_path && max_img_path != "") {
  //             url = max_img_path
  //         }
  //         array.projectData = Slider
  //         let authData = JSON.parse(localStorage.getItem("animation_studio_2.0_access_token"));
  //         let UserProjects = {
  //             Id: id, //array.id,
  //             ProjectName: array.projectName,
  //             UserId: array.userId,
  //             RespectiveUserId: array.respectiveUserId,
  //             IsExported: array.isExported,
  //             CanvasSize: array.canvasSize,
  //             ExportCount: array.exportCount,
  //             PreviewImagePath: url,
  //             DateCreated: array.dateCreated,
  //             DateModified: array.dateModified,
  //             ProjectData: JSON.stringify(array.projectData),
  //         }
  //         axios.post(authenticationData.ApiBaseURL + "/api/Project/UpdateProject", UserProjects, {
  //             headers: {
  //                 "Content-Type": "application/json",
  //                 "Access-Control-Allow-Origin": "*",
  //                 Authorization: "Bearer " + authData.access_token,
  //             },
  //         }).then(response => {
  //             if (response.data.status == true) {
  //                 let array = clone(CurrentProject);
  //                 const Slider = Array.from(slides);
  //                 for (let i = 0; i < Slider.length; i++) {
  //                     if (Slider[i].IsActive === true) {
  //                         Slider[i].LayerData = props.LayersData
  //                         break
  //                     }
  //                 }
  //                 array.projectData = JSON.stringify(Slider)

  //             }
  //             resolve()
  //         }).catch(excetion => {
  //             console.log(excetion)
  //             reject()
  //         });
  //     }})
  // })}
  // }

  //   const saveProject = () => {

  //       if (Role != "admin") {
  //           setChangeCount(6);
  //       } else {
  //           let project = clone(CurrentProject)//JSON.parse(localStorage.getItem("CurrentChooseProject"))
  //           if (project.id == 0) {
  //               setDeafultLoader({ played: true, stat: true })
  //               CreateTemplate().then(function (data) {

  //                   updateTemplate(data.currentItem.id).then(function () {

  //                       setDeafultLoader({ played: true, stat: false })
  //                       swal("Excellent", "Project saved", "success");
  //                   }).catch(function () {
  //                       swal("Failed", "Project not saved", "error");
  //                   });
  //               })
  //           array.projectData = JSON.stringify(Slider);
  //           if (data.result) {
  //             setAllProject(data.result);
  //           } else {
  //             setAllProject([]);
  //           }
  //           setCurrentProject(JSON.parse(JSON.stringify(array)));

  //           localStorage.setItem("CurrentChooseProject", JSON.stringify(array));

  //           // localStorage.setItem('CurrentChooseProject', JSON.stringify(data.currentItem));
  //           resolve(data);
  //           // history.push('./editor')
  //         }
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         reject();
  //       });
  //   // });
  // };

  const updateTemplate = (id) => {
    return new Promise(async (resolve, reject) => {
      let array = clone(CurrentProject);
      const Slider = Array.from(slides);
      props.LayersData.map((value) => {
        value.DrapEndAnimatedText = false;
        value.endTimeOfAnimatedText = undefined;
        value.speedOn = false;
        value.fastspeedOn = false;
        value.startTimeOnTimeline = false;
        value.LoadLottie = true;
      });

      for (let i = 0; i < Slider.length; i++) {
        if (Slider[i].IsActive === true) {
          Slider[i].LayerData = props.LayersData;
          break;
        }
      }

      for (let i = 0; i < Slider.length; i++) {
        Slider[i].CurrentProject = null;
      }

      let url = null;
      let check = false;
      for (let i = 0; i < Slider.length; i++) {
        if (Slider[i].SlideImage != null) {
          url = Slider[i].SlideImage;
          check = true;
          break;
        }
      }
      if (check == false) {
        for (let i = 0; i < Slider.length; i++) {
          if (Slider[i].SlideBackground.Path != null) {
            url = Slider[i].SlideBackground.Path;
            break;
          }
        }
      }
      let max_img_path = sessionStorage.getItem("max_img_path");

      if (max_img_path && max_img_path != "") {
        url = max_img_path;
      }
      array.projectData = Slider;
      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );

      Slider.forEach((element) => {
        element.LayerData.forEach((element) => {
          if (element.type === "Character") {
            //element.JSONValue = null;
            element.OriginalJSONValue = null;
          }
        });
      });

      let UserProjects = {
        Id: id, //array.id,
        ProjectName: array.projectName,
        UserId: array.userId,
        RespectiveUserId: array.respectiveUserId,
        IsExported: array.isExported,
        CanvasSize: array.canvasSize,
        ExportCount: array.exportCount,
        PreviewImagePath: url,
        DateCreated: array.dateCreated,
        DateModified: array.dateModified,
        ProjectData: await prepareProjectData(array.projectData),
        Watermark: JSON.stringify(watermark),
        BackgroundMusic: JSON.stringify(bgmusicState),
      };
      postJson(
          authenticationData.ApiBaseURL + "/api/Project/UpdateProject",
          UserProjects,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          if (response.data.status != true) {
            // The caller shows "Project not saved".
            reject(new Error((response.data && response.data.message) || "Template not saved"));
            return;
          }
          if (response.data.status == true) {
            setchanges(true); // the caller shows "Project saved"
            // let array = clone(CurrentProject);
            // const Slider = Array.from(slides);
            // for (let i = 0; i < Slider.length; i++) {
            //   if (Slider[i].IsActive === true) {
            //     Slider[i].LayerData = props.LayersData;
            //     break;
            //   }
            // }
            // array.projectData = JSON.stringify(Slider);
          }
          resolve();
        })
        .catch((excetion) => {
          console.log(excetion);
          reject(excetion instanceof Error ? excetion : new Error("Template not saved"));
        });
    });
  };

  const updateUserProject = async (isAutoSaving) => {
    if (!isAutoSaving) setDeafultLoader({ played: true, stat: true });
    let array = clone(CurrentProject);
    const Slider = Array.from(slides);

    Slider.forEach((element) => {
      element.LayerData.forEach((element) => {
        element.EditorZoom = projectEditorZoom;
        element.index = element.layerIndex;
        if (element.type === "Character") {
          //element.JSONValue = null;
          element.OriginalJSONValue = null;
        }
      });
    });

    for (let i = 0; i < Slider.length; i++) {
      if (Slider[i].IsActive === true) {
        Slider[i].LayerData = LayersData;
        break;
      }
    }

    for (let i = 0; i < Slider.length; i++) {
      Slider[i].CurrentProject = null;
    }

    let url = null;
    let check = false;
    for (let i = 0; i < Slider.length; i++) {
      if (Slider[i].SlideImage != null) {
        //url = authenticationData.ApiBaseURL + '/' + Slider[i].SlideImage
        url = Slider[i].SlideImage;
        check = true;
        break;
      }
    }
    if (check == false) {
      for (let i = 0; i < Slider.length; i++) {
        if (Slider[i].SlideBackground.Path != null) {
          url = Slider[i].SlideBackground.Path;
          break;
        }
      }
    }
    array.projectData = Slider;
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );
    let UserProjects = {
      Id: array.id,
      ProjectName: array.projectName,
      UserId: array.userId,
      RespectiveUserId: array.respectiveUserId,
      IsExported: array.isExported,
      CanvasSize: array.canvasSize,
      ExportCount: array.exportCount,
      PreviewImagePath: url,
      DateCreated: array.dateCreated,
      DateModified: array.dateModified,
      ProjectData: await prepareProjectData(array.projectData),
      Watermark: JSON.stringify(watermark),
      BackgroundMusic: JSON.stringify(bgmusicState),
    };
    postJson(
        authenticationData.ApiBaseURL + "/api/Project/UpdateProject",
        UserProjects,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        clearInterval(interval.current);
        if (response.data.status == true) {
          // If the server had to create the project again (e.g. it was removed meanwhile), keep
          // saving into that new project instead of creating another one on every save.
          if (response.data.id && CurrentProject.id !== response.data.id) {
            CurrentProject.id = response.data.id;
          }
          if (isAutoSaving) {
            setchanges(true);
            const Slider = Array.from(slides);
            for (let i = 0; i < Slider.length; i++) {
              if (Slider[i].IsActive === true) {
                Slider[i].LayerData = LayersData;
                break;
              }
            }
            // (No full copy in localStorage any more: nothing reads it and big projects do not fit.)
            localStorage.removeItem("CurrentChooseProject");
          } else {
            setDeafultLoader({ played: true, stat: false });
            swal("Excellent", "Project saved", "success");
            setchanges(true);
            if(response && response.status)CurrentProject['isSaved']=true
            const Slider = Array.from(slides);
            for (let i = 0; i < Slider.length; i++) {
              if (Slider[i].IsActive === true) {
                Slider[i].LayerData = LayersData;
                break;
              }
            }
            // (No full copy in localStorage any more: nothing reads it and big projects do not fit.)
            localStorage.removeItem("CurrentChooseProject");
          }
        } else {
          setDeafultLoader({ played: false, stat: false });
          if (!isAutoSaving) {
            swal(
              "Not saved",
              (response.data && response.data.message) || "The project could not be saved. Please try again.",
              "error"
            );
          }
        }
      })
      .catch((excetion) => {
        console.log(excetion);
        setDeafultLoader({ played: false, stat: false });
        if (!isAutoSaving) {
          const status = excetion && excetion.response && excetion.response.status;
          swal(
            "Not saved",
            status === 401 || status === 403
              ? "Your session has expired. Please sign in again, then save."
              : status === 413
              ? "This project is too large to save."
              : "Could not reach the server. Please check your connection and try again.",
            "error"
          );
        }
      });
    setChangeCount(0);
  };

  const CaptureSS_Node = async () => {
    let canvasHeight, canvasWidth;
    const _slide = Array.from(slides);
    var _currentSlidKey = null;
    for (let i = 0; i < _slide.length; i++) {
      if (_slide[i].IsActive) {
        slides[i].LayerData = LayersData; // as before: the active slide holds the current layers
        slides[i].slideLoader = true; // the slide list shows its loader until the thumbnail is back
        // Work on copies. The steps below turn pictures, shapes and characters into embedded
        // images for the thumbnail only; done on the editor's own layers, they replaced each
        // picture's link with a full copy that was then saved with the project (megabytes).
        _slide[i] = {
          ..._slide[i],
          SlideBackground: { ...(_slide[i].SlideBackground || {}) },
          LayerData: LayersData.map((layer) => ({ ...layer })),
        };
        _slide[i].CurrentProject = CurrentProject;
        _currentSlidKey = _slide[i].key;
        _slide[i].slideLoader = true;

        let _editor = document.getElementsByClassName("Editor")[0];
        _slide[i].clientHeight = _editor.clientHeight;
        _slide[i].clientWidth = _editor.clientWidth;

        if (_slide[i].SlideBackground.type === "image") {
          _slide[i].SlideBackground.convertedImage = await loadImage(
            authenticationData.ApiBaseURL + "/" + _slide[i].SlideBackground.Path
          );
          resizedataURL(
            _slide[i].SlideBackground.convertedImage,
            1920,
            1080
          ).then(async (newurl) => {
            _slide[i].SlideBackground.convertedImage = newurl;
          });
        } else if (_slide[i].SlideBackground.type === "Animated") {
          _slide[i].SlideBackground.convertedAnimated = await loadImage(
            authenticationData.ApiBaseURL + "/" + _slide[i].SlideBackground.Path
          );
          resizedataURL(
            _slide[i].SlideBackground.convertedAnimated,
            1920,
            1080
          ).then(async (newurl) => {
            _slide[i].SlideBackground.convertedAnimated = newurl;
          });
        } else if (_slide[i].SlideBackground.type === "gradient") {
          _slide[i].gradientBackground = _editor.style.background;
        }

        for (let j = 0; j < _slide[i].LayerData.length; j++) {
          if (_slide[i].LayerData[j].type === "image") {
            _slide[i].LayerData[j].ImageSrc = await loadImage(
              _slide[i].LayerData[j].ImageSrc
            );
            // resizedataURL(_slide[i].LayerData[j].ImageSrc, 1920, 1080).then(async (newurl) => {
            //   _slide[i].LayerData[j].ImageSrc = newurl;
            //   _slide[i].LayerData[j].ConvertedImageSrc = newurl;
            // })
          } else if (_slide[i].LayerData[j].type === "Shape") {
            var path = _slide[i].LayerData[j].ShapePath.replace(
              authenticationData.ApiBaseURL + "/",
              ""
            );
            _slide[i].LayerData[j].convertedShapePath = await loadImage(path);
            resizedataURL(
              _slide[i].LayerData[j].convertedShapePath,
              1920,
              1080
            ).then(async (newurl) => {
              _slide[i].LayerData[j].convertedShapePath = newurl;
            });
          } else if (_slide[i].LayerData[j].type === "Video") {
            _slide[i].LayerData[j].ConvertedImageSrc = await loadImage(
              _slide[i].LayerData[j].ImageSrc
            );
            // resizedataURL(_slide[i].LayerData[j].ConvertedImageSrc , 1920, 1080).then(async (newurl) => {
            //   _slide[i].LayerData[j].ImageSrc = newurl;
            //   _slide[i].LayerData[j].ConvertedImageSrc = newurl;
            // })
          } else if (_slide[i].LayerData[j].type === "Props") {
            _slide[i].LayerData[j].convertedPropsImage = await loadImage(
              _slide[i].LayerData[j].PropImage
            );

            // resizedataURL(_slide[i].LayerData[j].convertedPropsImage, 1920, 1080).then(async (newurl) => {
            //   _slide[i].LayerData[j].convertedPropsImage = newurl;
            // });
          } else if (_slide[i].LayerData[j].type === "Character") {
            let charDiv = document.getElementById(
              "Outer-" + _slide[i].LayerData[j].AnimationId
            );

            if (charDiv) {
              let svg = charDiv.firstChild.firstChild;
              if (svg) {
                _slide[i].LayerData[j].convertedSvg = await loadCharacter(svg);
              }
            }
          } else if (_slide[i].LayerData[j].type === "AnimatedText") {
            let charDiv = document.getElementById(
              "Outer-" + _slide[i].LayerData[j].AnimationId
            );

            if (charDiv) {
              let svg = charDiv.firstChild.firstChild;
              if (svg) {
                _slide[i].LayerData[j].convertedSVG = await loadCharacter(svg);
              }
            }
          } else if (_slide[i].LayerData[j].type === "basicShape") {
            let charDiv = document.getElementById(
              "default-shape-" + _slide[i].LayerData[j].key
            );

            _slide[i].LayerData[j].convertedBasicShape = await loadBasicShape(
              charDiv
            );

            resizedataURL(
              _slide[i].SlideBackground.convertedBasicShape,
              1920,
              1080
            ).then(async (newurl) => {
              _slide[i].SlideBackground.convertedBasicShape = newurl;
            });
          }
        }
        _slide[i].CurrentProject = null;
      }
    }

    _slide.forEach((element) => {
      element.LayerData.forEach((element) => {
        element.EditorZoom = projectEditorZoom;
        element.index = element.layerIndex;
        if (element.type === "Character") {
          //element.JSONValue = null;
          //element.OriginalJSONValue= null;
        }
      });
    });
    var activeSlideData = _slide.filter((x) => x.IsActive == true);
    if (CurrentProject.canvasSize == "16:9") {
      canvasWidth = 1920;
      canvasHeight = 1080;
    } else if (CurrentProject.canvasSize == "9:16") {
      canvasWidth = 1080;
      canvasHeight = 1920;
    } else if (CurrentProject.canvasSize == "1:1") {
      canvasWidth = 1080;
      canvasHeight = 1080;
    }

    let exportObj = {
      SlideData: JSON.stringify(activeSlideData),
      Width: canvasWidth,
      Height: canvasHeight,
      bpath: "",
      FileName: CurrentProject.previewImagePath,
      ProjectId: CurrentProject.id,
      ProjectName: CurrentProject.projectName,
      CanvasSize: CurrentProject.canvasSize,
      CurrentSlideKey: _currentSlidKey,
      // projectEditorZoom:projectEditorZoom
    };

    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );
    var formData = new FormData();
    formData.append("value", JSON.stringify(exportObj));
    axios
      .post(
        authenticationData.ApiBaseURL + "/api/Export/CatureSSNode",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        const concat = thumbnailPathFrom(response.data);

        //setCall_ScreenShot(false);
        setSlide_background_image({
          path: concat,
          slide_key: response.data.key,
        });
        // for (let i = 0; i < slides.length; i++) {
        //   if (slides[i].IsActive && _slide[i].key==_currentSlidKey) {
        //     slides[i].SlideImage = concat;
        //   }
        // }
        //setslides(_slide);
      })
      .catch((error) => {
        // The thumbnail could not be made: keep the old one and stop the slide's loader
        // (before, the loader kept spinning and no later thumbnail was taken).
        console.log("Slide thumbnail could not be created.", error);
        setCall_ScreenShot(false);
        const _active = slides.find((s) => s.key === _currentSlidKey);
        setSlide_background_image({
          path: _active ? _active.SlideImage : null,
          slide_key: _currentSlidKey,
        });
      });
  };

  // useEffect(() => {
  //   if (Call_ScreenShot) {
  //     CaptureSS_Node();
  //     setCall_ScreenShot(false);
  //   }
  // }, [Call_ScreenShot]);

  function loadImage(path) {
    return new Promise(async (resolve, reject) => {
      if (!path.includes(".svg")) {
        let imSrc = path;
        if (
          !path.includes("data:image/png;base64") &&
          !path.includes("data:image/jpeg;base64")
        ) {
          imSrc = await getImageSrc(path);
        }
        resolve(imSrc);
        // let img = new Image();
        // img.onload = function () {
        //   resolve(img);
        // };
        // img.src = imSrc;
      } else if (path.includes(".svg")) {
        let authData = JSON.parse(
          localStorage.getItem("animation_studio_2.0_access_token")
        );
        axios
          .get(
            authenticationData.ApiBaseURL + "/api/Asset/getAsset?path=" + path,
            {
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + authData.access_token,
              },
            }
          )
          .catch(() => ({ data: path }))
          .then((response) => {
            resolve(response.data);

            // console.log(response.data);
            // let img = new Image();
            // img.onload = function () {
            //   resolve(img);
            // };
            // img.src = response.data;
          });
      }
    });
  }

  function getImageSrc(url) {
    // Falls back to the plain URL if the conversion fails, instead of waiting forever.
    return ImageURLToBase64(url).catch(() => url);
  }

  const ImageURLToBase64 = (url) => {
    return new Promise((resolve, reject) => {
      var splittedURL = url.split("/");
      var imageName = splittedURL[splittedURL.length - 1];
      var extension = imageName.split(".")[1];

      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );
      axios
        .get(
          authenticationData.ApiBaseURL +
            "/api/Images/ImageURLToBase64?url=" +
            url,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          if (response.data != null && response.data != "") {
            var format = "data:image/jpeg;base64,";
            if (extension.toLowerCase() === "png") {
              format = "data:image/png;base64,";
            }
            var baseStr = format + response.data;

            resolve(baseStr);
          } else {
            reject();
          }
        })
        .catch((error) => {
          //console.log(error);
          reject();
        });
    });
  };

  // Resizes a picture for the slide thumbnail. When the picture is an address on another site that
  // does not allow reading its pixels (the base64 conversion fell back to the plain address), the
  // canvas cannot be read: the picture is then used as it is instead of throwing an uncaught
  // SecurityError ("Tainted canvases may not be exported").
  var resizedataURL = function (base64, wantedWidth, wantedHeight) {
    return new Promise(function (resolve) {
      if (!base64 || typeof base64 !== "string") return resolve(base64);
      var img = document.createElement("img");
      if (/^https?:/i.test(base64)) img.crossOrigin = "anonymous";
      img.onload = function () {
        try {
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");
          canvas.width = wantedWidth;
          canvas.height = wantedHeight;
          ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);
          resolve(canvas.toDataURL("image/jpeg", 0.85));
        } catch (e) {
          resolve(base64);
        }
      };
      img.onerror = function () {
        resolve(base64);
      };
      img.src = base64;
    });
  };

  function loadCharacter(svg) {
    return new Promise((resolve, reject) => {
      try {
        var xml = new XMLSerializer().serializeToString(svg);
        resolve(xml);
        //resolve(div);
      } catch (error) {}
    });
  }

  function loadBasicShape(svg) {
    return new Promise((resolve, reject) => {
      try {
        var xml = new XMLSerializer().serializeToString(svg);
        var svg64 = btoa(xml);
        var b64Start = "data:image/svg+xml;base64,";
        var image64 = b64Start + svg64;
        resolve(image64);
      } catch (error) {}
    });
  }

  const saveProject = (isAutoSaving) => {
    //  if(!Call_ScreenShot)
    //  {
    //    setCall_ScreenShot(true);
    //  }
    //CaptureSS_Node();

    if (Role != "admin") {
      //setChangeCount(6);

      updateUserProject(isAutoSaving);
    } else {
      setDeafultLoader({ played: true, stat: true });
      let project = clone(CurrentProject); //JSON.parse(localStorage.getItem("CurrentChooseProject"))
      if (project.id == 0) {
        CreateTemplate().then(function (data) {
          updateTemplate(data.currentItem.id)
            .then(function () {
              clearInterval(interval.current);
              setDeafultLoader({ played: true, stat: false });
              swal("Excellent", "Project saved", "success");
              setchanges(true);
            })
            .catch(function () {
              clearInterval(interval.current);
              setDeafultLoader({ played: true, stat: false });
              swal("Failed", "Project not saved", "error");
              setchanges(false);
            });
        }).catch(function () {
          clearInterval(interval.current);
          setDeafultLoader({ played: true, stat: false });
          swal("Failed", "Template could not be created", "error");
          setchanges(false);
        });
      } else {
        updateTemplate(project.id)
          .then(function () {
            clearInterval(interval.current);
            setDeafultLoader({ played: true, stat: false });
            swal("Excellent", "Project saved", "success");
            setchanges(true);
          })
          .catch(function () {
            clearInterval(interval.current);
            setDeafultLoader({ played: true, stat: false });
            swal("Failed", "Project not saved", "error");
            setchanges(false);
          });
      }
    }
  };

  // const OpenAdminPanel = () => {
  //     props.setAdminPanelPopup(true);
  // }

  const OpenAdminPanel = () => {
    props.setAdminPanelPopup(true);
  };

  const OpenSmartCharacterBuilder = () => {
    props.setShowSmartCharaterBuilderPanel(true);
  };

  const OpenLinkGenerator = () => {
    if (Access !== "FE" && Access !== "US1") props.setLinkGenPop(true);
    else {
      Swal.fire({
        title: "Upgrade Required",
        html: `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
        icon: "info",
        cancelButtonColor: "#d33",
        backdrop: null,
      });
    }
  };

  const CallForExport = () => {
    const somethingWrong = () =>
      swal({
        title: "Something went wrong.",
        text: "Please contact support for further assistance.",
        icon: "error",
        dangerMode: false,
        backdrop: null,
      });

    listMyExports(authenticationData.ApiBaseURL)
      .then((videos) => {
        // Checking total count of renders in My Videos Tab
        if (videos.length >= 15) {
          swal({
            title: "Please Clean Up My Videos",
            text: "Maximum 15 videos should be in 'My Videos'. You can render unlimited videos, please download the finished videos and delete the completed items in the 'My Videos' tab before rendering new video.",
            icon: "warning",
            dangerMode: false,
            backdrop: null,
          }).then((value) => {
            if (value) setMyVideoRenderModel(true);
          });
          return;
        }

        Swal.fire({
          title: "Ready for export?",
          html: "Make sure you have saved the project and everything is in place.<br/><br/><b>Video format</b>",
          icon: "info",
          input: "radio",
          inputOptions: { mp4: "MP4 (recommended)", webm: "WebM" },
          inputValue: "mp4",
          showCancelButton: true,
          confirmButtonText: "Start Render",
          backdrop: null,
        }).then((result) => {
          if (result.isConfirmed) {
            props.setCallForExport({
              status: true,
              fps: 30,
              format: result.value === "webm" ? "webm" : "mp4",
            });
          }
        });
      })
      .catch((err) => {
        const status = err && err.response && err.response.status;
        if (status === 401 || status === 403) {
          swal({
            title: "Please sign in again",
            text: "Your session has expired.",
            icon: "warning",
            backdrop: null,
          });
        } else {
          somethingWrong();
        }
      });
  };

  const showSizePopup = () => {
    swal({
      title: "Are you sure to delete?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result) {
      }
    });
  };

  return (
    <>
      <div className="navbarWrapper">
        <div className="navbarInsider">
          <div className="navbarLeftMenu">
            <div className="mr-3 LogoArea">
              <div
                onClick={() => {
                  props.setDashPop(true);
                }}
                className="logoIconWrapper"
              >
                <div className="hoverIconTimeline">
                  <img
                    className="timelinePlayerIconsNormal"
                    style={{ marginRight: "0px" }}
                    src="../AppIcons/IconsAll/burger.svg"
                    alt=""
                  />
                  <img
                    className="timelinePlayerIconsHover"
                    style={{ marginRight: "0px" }}
                    src="../AppIcons/IconsAll/burger_hover.svg"
                    alt=""
                  />
                </div>
                {/* <span className="material-icons">menu</span> */}
              </div>
              <div className="logoTransition logoSize">
                <img style={{ height: "25px" }} src="images/Logo.png" alt="" />
              </div>
            </div>
            <div className="projectSaveArea">
              {NameChange === true && (
                <Tooltip
                  position="bottom"
                  size="small"
                  title="Rename"
                  trigger="mouseenter"
                  theme="transparent"
                  arrow={true}
                  animation="scale"
                >
                  <div
                    className="projectName mr-2"
                    onClick={() => changeName()}
                  >
                    <div className="pname">{Name}</div>
                    <div className="picon">
                      <img
                        className="timelinePlayerIconsNormal"
                        style={{ marginRight: "0px", width: "22px" }}
                        src="../AppIcons/IconsAll/edit.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </Tooltip>
              )}

              {NameChange === false && (
                <div className="projectName mr-2">
                  <input
                    id="pnameID"
                    type="text"
                    className="ProjectNameInput"
                    onBlur={(event) => Textblur(event)}
                    onKeyDown={(event) => ChangedName(event)}
                    value={Name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
              )}

              {changes === true && (
                <>
                  <Tooltip
                    size="small"
                    title="Project saved"
                    position="bottom"
                    trigger="mouseenter"
                    theme="transparent"
                    arrow={true}
                    animation="scale"
                  >
                    <div
                      className="savingStatus"
                      onClick={() => {
                        saveProject(false);
                      }}
                    >
                      <img
                        className="timelinePlayerIconsNormal"
                        style={{ marginRight: "0px", width: "27px" }}
                        src="../AppIcons/IconsAll/projectSaved.svg"
                        alt=""
                      />
                    </div>
                  </Tooltip>
                </>
              )}
              {changes === false && (
                <>
                  <Tooltip
                    size="small"
                    title="Click to save project"
                    position="bottom"
                    trigger="mouseenter"
                    theme="transparent"
                    arrow={true}
                    animation="scale"
                  >
                    <div
                      className="savingStatus"
                      onClick={() => {
                        saveProject(false);
                      }}
                    >
                      <img
                        className="timelinePlayerIconsNormal"
                        style={{ marginRight: "0px", width: "27px" }}
                        src="../AppIcons/IconsAll/projectSaving.svg"
                        alt=""
                      />
                    </div>
                  </Tooltip>
                </>
              )}
              <Tooltip
                size="small"
                title="Resize Canvas "
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
              >
                <CustomDropDown
                  canvasSize={CurrentProject.canvasSize}
                  CurrentProject={CurrentProject}
                  setCurrentProject={setCurrentProject}
                  setchanginCanvasSize={setchanginCanvasSize}
                ></CustomDropDown>
              </Tooltip>
            </div>
          </div>

          <div className="navbarRightMenu">
            {Role == "admin" && (
              <Tooltip
                size="small"
                title="Character builder"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
              >
                <div
                  className="hoverIconTimeline"
                  onClick={OpenSmartCharacterBuilder}
                >
                  <img
                    className="timelinePlayerIconsNormal"
                    style={{ margin: "0px 12px" }}
                    src="../AppIcons/IconsAll/characterBuilder.svg"
                    alt=""
                  />
                  <img
                    className="timelinePlayerIconsHover"
                    src="../AppIcons/IconsAll/characterBuilder_hover.svg"
                    alt=""
                    style={{ margin: "0px 12px" }}
                  />
                </div>
              </Tooltip>
            )}
            {Role == "admin" && (
              <Tooltip
                size="small"
                title="Asset manger"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
              >
                <div className="hoverIconTimeline" onClick={OpenAdminPanel}>
                  <img
                    className="timelinePlayerIconsNormal"
                    src="../AppIcons/IconsAll/assetManager.svg"
                    alt=""
                    style={{ margin: "0px 12px" }}
                  />
                  <img
                    className="timelinePlayerIconsHover"
                    src="../AppIcons/IconsAll/assetManager_hover.svg"
                    alt=""
                    style={{ margin: "0px 12px" }}
                  />
                </div>
              </Tooltip>
            )}
            <Tooltip
              size="small"
              title="Generate Video Page Link"
              position="bottom"
              trigger="mouseenter"
              theme="transparent"
              arrow={true}
              animation="scale"
            >
              <div
                className="hoverIconTimeline"
                onClick={OpenLinkGenerator}
                style={{ position: "relative" }}
              >
                {(Access === "FE" || Access === "US1") && (
                  <img
                    style={{
                      position: "absolute",
                      top: "-4px",
                      right: "-2px",
                      width: "16px",
                      height: "16px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50%",
                      zIndex: "1",
                    }}
                    src="../AppIcons/IconsAll/PremiumIcon.svg"
                    alt=""
                  />
                )}

                <img
                  className="timelinePlayerIconsNormal"
                  src="../AppIcons/IconsAll/link.svg"
                  alt=""
                  style={{ margin: "0px 12px" }}
                />
                <img
                  className="timelinePlayerIconsHover"
                  src="../AppIcons/IconsAll/linkHover.svg"
                  alt=""
                  style={{ margin: "0px 12px" }}
                />
              </div>
            </Tooltip>
            <Tooltip
              size="small"
              title="Reset project"
              position="bottom"
              trigger="mouseenter"
              theme="transparent"
              arrow={true}
              animation="scale"
            >
              <div className="hoverIconTimeline" onClick={clearAll}>
                <img
                  className="timelinePlayerIconsNormal"
                  src="../AppIcons/IconsAll/refresh.svg"
                  alt=""
                  style={{ margin: "0px 12px" }}
                />
                <img
                  className="timelinePlayerIconsHover"
                  src="../AppIcons/IconsAll/refresh_hover.svg"
                  alt=""
                  style={{ margin: "0px 12px" }}
                />
              </div>
            </Tooltip>

            <audio
              controls
              id="bgmusicAudioPlayer_preview"
              style={{ display: "none" }}
            >
              <source src="" type="audio/mp3" />
            </audio>
            <Tooltip
              size="small"
              title="Preview"
              position="bottom"
              trigger="mouseenter"
              theme="transparent"
              arrow={true}
              animation="scale"
            >
              <div
                className="hoverIconTimeline"
                onClick={() => {
                  showPreview();
                }}
              >
                <img
                  className="timelinePlayerIconsNormal"
                  src="../AppIcons/IconsAll/preview.svg"
                  alt=""
                  style={{ margin: "0px 12px" }}
                />
                <img
                  className="timelinePlayerIconsHover"
                  src="../AppIcons/IconsAll/preview_hover.svg"
                  alt=""
                  style={{ margin: "0px 12px" }}
                />
              </div>
            </Tooltip>

            <div style={{ margin: "0px 10px 0px 10px" }}>
              <button
                className="btn btn-publish btn-strong"
                onClick={(e) => setMyVideoRenderModel(true)}
              >
                My Videos
              </button>
            </div>
            <div style={{ margin: "0px 10px 0px 10px" }}>
              <button
                onClick={() => {
                  if(CurrentProject.isSaved)CallForExport();
                  else {
                    swal({
                      title: "Save Project",
                      text: "Make sure to save your project before render",
                      icon: "info",
                      // buttons: [true],
                      cancelButtonColor: "#d33",
                      // confirmButtonText: "Yes, Clear it!",
                      dangerMode: true,
                      backdrop: null,
                    })
                  }
                }}
                className="btn btn-publish btn-strong"
              >
                Publish
              </button>
            </div>
            {/* <div className="RightMenu">
              <div className="RightMenuInsider">
                <div className="RightMenuContent">
                  <Tooltip
                    size="small"
                    title="logout"
                    position="bottom-start"
                    trigger="mouseenter"
                    theme="transparent"
                    arrow={true}
                    animation="scale"
                  >
                    <span
                      onClick={LogOut}
                      className="rightTopIcon material-icons"
                    >
                      logout
                    </span>
                  </Tooltip>
                </div>
              </div>
            </div> */}
            {/* <UserDropDown /> */}

            <MyVideoRenders
              setDeafultLoader={setDeafultLoader}
              open={MyVideoRenderModel}
              close={setMyVideoRenderModel}
              apiBaseURL={authenticationData.ApiBaseURL}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default Navbar;
